import {
  HOME_PAGE_LOADED,
  HOME_PAGE_UNLOADED,
  TRANSACTION_DETAIL_LOADED,
  TRANSACTION_DETAIL_UNLOADED,
  ACCOUNT_DETAIL_LOADED,
  ACCOUNT_DETAIL_UNLOADED,
  ASYNC_START
} from '../constants/actionTypes';
import { BASE_COIN_SYMBOL } from '../constants/config'

export default (state = {}, action) => {
  switch (action.type) {
    case HOME_PAGE_LOADED:
      return {
        ...state,
        categories: action.payload[0].categories,
        products: action.payload[1].products,
      };
    case TRANSACTION_DETAIL_LOADED:
      return {
        ...state,
        transaction: action.error ? null : action.payload[0].transaction
      }
    case ACCOUNT_DETAIL_LOADED:
      return {
        ...state,
        account: action.error ? null : action.payload.account,
      }
    case HOME_PAGE_UNLOADED:
    case TRANSACTION_DETAIL_UNLOADED:
    case ACCOUNT_DETAIL_UNLOADED:
      return {};
    case ASYNC_START:
      if (action.subtype === TRANSACTION_DETAIL_LOADED || action.subtype === ACCOUNT_DETAIL_LOADED) {
        return {
          ...state,
          transaction: null,
          account: null
        }
      }
    default:
      return state;
  }
};
